import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import Table from "@/components/table";
import TableFooter from "@/components/table/footer";
import TablePagination from "@/components/table/pagination";
import { Order } from "@/types";
import { exportToCSV } from "@/utils/export-to-csv";
import { useEffect } from "react";
import { Box } from "rizzui";
import { paymentOrderListColumns } from "./columns";
import Filters from "./filters";


type OrderListTableProps = {
    orders: Order[];
    refresh(): void;
};

export default function PaymentListTable({ orders, refresh }: OrderListTableProps) {
    const { table, setData } = useTanStackTable<Order>({
        tableData: orders,
        columnConfig: paymentOrderListColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 10,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                    table.resetRowSelection();
                },
                handleMultipleDelete: (rows) => {
                    setData((prev) => prev.filter((r) => !rows.includes(r)));
                    table.resetRowSelection();
                },
            },
            enableColumnResizing: false,
        },
    });

    useEffect(() => {
        setData(orders);
    }, [orders, setData]);

    const selectedData = table
        .getSelectedRowModel()
        .rows.map((row) => row.original);

    function handleExportData() {
        exportToCSV(
            selectedData,
            "ID,TrackingNumber,CustomerName,CustomerEmail,ShippingDate,Status,Cost,CreatedAt",
            `order_data_${selectedData.length}`,
        );
    }

    return (
        <Box>
            <Filters table={table} />
            <Table
                table={table}
                variant="elegant"
                classNames={{
                    headerCellClassName:
                        "[&>div]:last:flex [&>div]:last:justify-end [&>div]:last:pe-4",
                }}
            />
            <TableFooter table={table} onExport={handleExportData} />
            <TablePagination table={table} className="py-4" />
        </Box>
    );
}
